module.exports = __webpack_public_path__ + "static/media/WhyChooseUs_old.b2ceef53.jpg";